
import React      from 'react';
import CSSModules from 'react-css-modules';
import classNames from 'classnames/bind';
import Helmet     from "react-helmet";

import style from './style.scss';

import PageHeader      from '../PageHeader';
import SideBar         from '../SideBar';
import ContentColumn   from '../ContentColumn';
import EventListItem   from '../EventListItem';
import SideBarMap      from '../SideBarMap';
import EventFilterBar  from '../EventFilterBar';
import Button          from '../Button';
import FontIcon        from '../FontIcon';
import ColumnContainer from '../ColumnContainer';

import { connect } from 'react-redux';

import * as eventListActions from '../../actions/publicEventList';
import GlobalMessage from "../GlobalMessage";

class EventsPage extends React.Component {
    
    componentDidMount() {
        
        this.props.refreshEvents();
        this.props.refreshModules();
    }

    _getFilterToggleClasses() {

        let cx = classNames.bind(style);

        return cx({
            'filter-toggle': true,
            'filter-toggle-borderless': this.props.isShowingMobileFilters
        });
    }

    _getFilterBarClasses() {

        let cx = classNames.bind(style);

        return cx({
            'filter-bar-wrapper': true,
            'filter-bar-wrapper--show': this.props.isShowingMobileFilters
        });
    }

    _getFilterIconName() {

        return classNames({
            'chevron-up': this.props.isShowingMobileFilters,
            'chevron-down': !this.props.isShowingMobileFilters
        });
    }

    _getFilterToggleText() {

        if (this.props.isShowingMobileFilters) {

            return 'Hide filters';

        } else {

            return 'Show filters';
        }
    }

    _getBookableEventCount() {
        return this.props.events.filter(e => !e.fully_booked).length;
    }

    render() {

        return (

            <article className={style['section-content']}>

                <Helmet>
                    <title>Training Events</title>
                    <meta name="description" content="View all our training events."/>
                </Helmet>

                <h2 className={style['programme-title--mobile']}>Events</h2>

                  <ColumnContainer>

                    <ContentColumn>

                        <div className={ this._getFilterBarClasses() }>

                            <span className={style['result-summary-mobile']}>
                                { this._getBookableEventCount() } Courses and Conferences<br />are available for booking
                            </span>

                            <div className={ this._getFilterToggleClasses() }>

                                <Button className={style['filter-button']} onClick={ this.props.toggleMobileFilters } theme="secondary">

                                    <span>
                                        { this._getFilterToggleText() }
                                    </span>

                                    <span className={style['filter-toggle-icon']}>
                                        <FontIcon iconName={ this._getFilterIconName() } />
                                    </span>

                                </Button>

                            </div>

                            <h2 className={style['programme-title--desktop']}>Events</h2>

                            <div className={ this._getFilterBarClasses() }>


                                {this.props.isShowingMobileFilters && (
                                    <EventFilterBar sortBy={ this.props.sortBy }
                                                    filterByEventType={ this.props.filterByEventType }
                                                    filterByModuleId={ this.props.filterByModuleId }
                                                    eventCount={ this._getBookableEventCount() }
                                                    modules={ this.props.modules }
                                                    sortChanged={ this.props.sortEvents }
                                                    moduleFilterChanged={ this.props.filterEventsByModuleId }
                                                    eventTypeFilterChanged={ this.props.filterEventsByEventType }
                                                    onSearch={ this.props.searchEvents }
                                    />
                                )}

                                <div className={style['desktop-filter']}>
                                    <EventFilterBar sortBy={ this.props.sortBy }
                                                    filterByEventType={ this.props.filterByEventType }
                                                    filterByModuleId={ this.props.filterByModuleId }
                                                    eventCount={ this._getBookableEventCount() }
                                                    modules={ this.props.modules }
                                                    sortChanged={ this.props.sortEvents }
                                                    moduleFilterChanged={ this.props.filterEventsByModuleId }
                                                    eventTypeFilterChanged={ this.props.filterEventsByEventType }
                                                    onSearch={ this.props.searchEvents }
                                    />
                                </div>
                            </div>

                            <section className={style['event-list']}>

                                {this.props.events.length === 0 && (
                                    <span>Sorry, your search returned no results.</span>
                                )}

                                {
                                    this.props.events.map((event, index) => {

                                        return <EventListItem key={ index } event={ event } />
                                    })
                                }

                            </section>

                        </div>

                    </ContentColumn>

                    <SideBar>

                        <h2 className={style['location-title']}>Locations</h2>

                        <SideBarMap events={ this.props.events } />
                    </SideBar>

                </ColumnContainer>

            </article>
        );
    }
}

function mapStateToProps(state) {

    return state.eventList;
}

function mapDispatchToProps(dispatch) {

    return {
        refreshModules() {

            dispatch(eventListActions.refreshModules());
        },
        sortEvents(sortBy) {

            dispatch(eventListActions.sortEventsBy(sortBy));
        },
        filterEventsByModuleId(moduleId) {

            dispatch(eventListActions.filterEventsByModuleId(moduleId));
        },
        filterEventsByEventType(eventType) {

            dispatch(eventListActions.filterEventsByEventType(eventType));
        },
        searchEvents(searchText) {

            dispatch(eventListActions.searchEvents(searchText));
        },
        refreshEvents() {
            
            dispatch(eventListActions.refreshEvents());
        },
        toggleMobileFilters() {

            dispatch(eventListActions.toggleMobileFilterVisibility());
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(EventsPage, style));


// WEBPACK FOOTER //
// ./components/EventsPage/index.js